<script setup>
// результаты для админстратора
//import TheCriteria from "@/components/Admin/TheCriteria";
import {useStore} from "vuex";
//import {useRoute} from "vue-router";
import {ref, onMounted, computed} from "vue";
import axios from "axios";

//----------------------------------------------------------------------

const store = useStore()
//const route = useRoute()
const results = ref([])
// имена членов жюри для таблицы
const users = ref([])
const isLoading = ref(false)
// рейтинг команды
const criteria = ref([])
//const totalSumma = ref([])

//----------------------------------------------------------------------

onMounted( ()=>{
  try {
    init()
  } catch (err) {
    alert ('APPLICATION ERROR')
  }
})

// eslint-disable-next-line no-undef
const props = defineProps({
  teamId:{
    type: String,
    required: true,
  },
  userId:{
    type: String,
    required: true,
  },
  taskId:{
    type: String,
    required: true,
  },
})

//----------------------------------------------------------------------

const init = async () => {
  isLoading.value = true

  // критерии оценок
  let urlCriteriaList = ""
  if (process.env.VUE_APP_CRITERIAS_TYPE === 0){
    //общие критерии для всех задач
    urlCriteriaList = process.env.VUE_APP_ADMIN_URL + "/api/data/criteriaList.php"
  } else {
    //отдельные критерии для каждой задачи
    urlCriteriaList = process.env.VUE_APP_ADMIN_URL + "/api/data/criteriaList_" + props.taskId + ".php"
  }

  const urlResults = process.env.VUE_APP_ADMIN_URL + "/api/results.php"
  const urlUsers = process.env.VUE_APP_ADMIN_URL + "/api/users.php"

  await axios
      .get(`${urlUsers}?token=${token.value}`)
      .then(response => (users.value = response.data))
      .then(
          await axios
              .get(`${urlResults}?teamId=${props.teamId}&token=${token.value}`)
              .then(response => (results.value = response.data))
      )
      .then(
          await axios
              .get(`${urlCriteriaList}`)
              .then(response => (criteria.value = response.data))
      )
      .catch(error => alert(error));
  isLoading.value = false

}

const createResult = (id) => {
  let result = ''
  let summa = 0

  results.value.forEach((item) => {
    if (item['userId'] === id) {
      result += '<p>' + item['created'] + '</p>';
      for (let i = 0; i < item['result'].length; i++){
        result += '<h4>' + item['result'][i]['title'] + '</h4>';
        for (let j = 0; j < item['result'][i]['sections'].length; j++) {
          summa += item['result'][i]['sections'][j]['activeIndex'];
          result += '<div class="d-flex justify-content-between">';
          result += '<div class="w-75">' + item['result'][i]['sections'][j]['name'] + '</div>';
          result += '<h2>' + item['result'][i]['sections'][j]['activeIndex'] + '</h2>';
          result += '</div>';
          result += '<hr>';
        }
      }
      result += '<div class="d-flex justify-content-between">';
      result += '<h2>Всего</h2>';
      result += '<h2 class="text-danger">' + summa + '</h2>';
      result += '</div>';
    }
  });

  if (summa === 0){
    result = '<h4 class="text-danger">Нет оценок</h4>';
  }

  return result
}
//----------------------------------------------------------------------
const total = () => {
  let summa = 0
  results.value.forEach((item) => {
      for (let i = 0; i < item['result'].length; i++){
        for (let j = 0; j < item['result'][i]['sections'].length; j++) {
          summa += item['result'][i]['sections'][j]['activeIndex'];
        }
      }
  });
  return summa
}

//----------------------------------------------------------------------
const token = computed( () => {return store.getters['authModule/token']})
//const user = computed( () => {return store.getters['authModule/user']})

</script>
<template>
  <div>
    <h3 class="text-center">Результаты оценки команды</h3>
    <div
        v-for="(item,index) in users" :key="index"
        class="card mt-4"
    >
      <div class="card-header bg-info"><h4 class="card-title">{{ item['name'] }}</h4></div>
      <div class="card-body" v-html="createResult(item['id'])"></div>
    </div>
    <h3 v-if="total() > 0" class="text-center mt-4">Общая сумма баллов: {{ total() }}</h3>
  </div>
</template>

<style scoped>
</style>